import { AlertOctagon } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { useWorkspace } from "../../store/WorkspaceContext";

// Pattern is wider than the film on the roll: "Error: Load 60" Roll to cut this pattern."
export const RollErrorDialog = () => {
  const { state, dispatch } = useWorkspace();
  const open = state.dialog === "rollError";
  const info = state.rollError || {};
  const close = () => dispatch({ type: "SET", patch: { dialog: null } });
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="panel3d max-w-sm border-[#e5484d]/40 bg-[#121824] text-[#e8e9ec]" data-testid="roll-error-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[15px] text-[#ff6b70]"><AlertOctagon className="h-5 w-5" /> <span data-testid="roll-error-message">Error: Load {info.width}" Roll to cut this pattern.</span></DialogTitle>
          <DialogDescription className="text-[#9aa0a8]">{info.name} is wider than the {state.rollWidth}" film on the roll. Load a {info.width}" roll, then set the width to W {Number(info.width || 0).toFixed(1)}".</DialogDescription>
        </DialogHeader>
        <button data-testid="roll-error-ok-btn" onClick={close} className="btn-red w-full">OK</button>
      </DialogContent>
    </Dialog>
  );
};
